import React, { useState, useEffect } from "react";
import {Form, Select, Checkbox} from "antd";
import { coreApi } from "../../api/calls";
import { BUILDING_COMMUNICATION_TYPES, PARTNER_COMMUNICATION_TYPES } from "../../constants/communicationTags";

const BuildingContactFilterPanel = ({
   filters,
   setFilters,
   fetchEmails,
   t,
   context = 'building', // 'building' or 'partner'
 }) => {

  const [form] = Form.useForm();
  const [communicationTypes, setCommunicationTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);

  useEffect(() => {
    const fetchCommunicationTypes = async () => {
      setLoadingTypes(true);
      try {
        const response = await coreApi.get("/contacts/communication-type-tags");

        if (response.data && Array.isArray(response.data)) {
          const allTypes = response.data.map(tag => tag.key || tag.name || tag);

          const allowedTypes = context === 'partner' 
            ? PARTNER_COMMUNICATION_TYPES 
            : BUILDING_COMMUNICATION_TYPES;
          
          const filteredTypes = allTypes.filter(type => allowedTypes.includes(type));
          setCommunicationTypes(filteredTypes);
        }
      } catch (error) {
        console.error("Error loading communication types:", error);
        // Fallback to context-specific values if API fails
        const fallbackTypes = context === 'partner' 
          ? PARTNER_COMMUNICATION_TYPES 
          : BUILDING_COMMUNICATION_TYPES;
        setCommunicationTypes(fallbackTypes);
      } finally {
        setLoadingTypes(false);
      }
    };

    fetchCommunicationTypes();
  }, [context]);
  
  const handleFilterChange = (changedValues) => {
    const currentValues = form.getFieldsValue();

    const updatedFilters = {
      ...filters,
      ...changedValues,
      claimTagIds: currentValues.claim_tag_id || filters.claimTagIds || [],
      page: 1,
    };

    setFilters(updatedFilters);
  };

  const handleSearch = () => {

    fetchEmails();
  };

  const handleResetClick = () => {
    form.resetFields();
    setFilters({cases: ['phone', 'email', 'action'], page: 1});
    fetchEmails();
  };

  useEffect(() => {
    if (filters.type !== undefined) {
      form.setFieldsValue({ type: filters.type });
    }
  }, [filters.type, form]);

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleFilterChange}
      onFinish={handleSearch}
      style={{ maxWidth: '1010px' }}
    >
      <Form.Item>
        <label style={{ marginRight: "15px"}}>{t("emails.communication")}</label>
        {['phone', 'email', 'schedule','action'].map((name) => (
          <Checkbox
            key={name}
            value={name}
            checked={filters.cases && filters.cases.includes(name)}
            onChange={(e) => {
              const cases = e.target.checked
                ? [...(filters.cases || []), name]
                : (filters.cases || []).filter((type) => type !== name);

              setFilters({
                ...filters,
                cases: cases,
                page: 1,
              });
            }}
          >
            { t("emails.communication_cases." + name) }
          </Checkbox>
        ))}
      </Form.Item>

      <Form.Item
        name="type"
        label={t("emails.communication_type")}
        style={{minWidth: '370px'}}
      >
        <Select
          mode="multiple"
          allowClear={true}
          loading={loadingTypes}
          placeholder={t("emails.select_communication_type")}
        >
          {communicationTypes.map((type) => (
            <Select.Option key={type} value={type}>
              {t("emails.types." + type)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default BuildingContactFilterPanel;
